import React from 'react';
import { classes } from './Illustration.classes';
import { dataHooks } from '../../constants';
import { useBaseModalLayoutContext } from '../../BaseModalLayoutContext';
import { IllustrationProps } from './Illustration.types';

export const Illustration = ({
  dataHook,
  className,
  children,
}: IllustrationProps = {}) => {
  const { illustrationClassName, illustration = children } =
    useBaseModalLayoutContext();

  return (
    (illustration && (
      <div
        data-hook={dataHook}
        className={classes.root({}, illustrationClassName, className)}
      >
        {typeof illustration === 'string' ? (
          <img
            className={classes.image()}
            src={illustration}
            data-hook={dataHooks.illustrationSrc}
          />
        ) : (
          illustration
        )}
      </div>
    )) ||
    null
  );
};
